import { render, staticRenderFns } from "./InventoryTransferAction.vue?vue&type=template&id=440ba208&scoped=true"
import script from "./InventoryTransferAction.vue?vue&type=script&lang=js"
export * from "./InventoryTransferAction.vue?vue&type=script&lang=js"
import "./InventoryTransferAction.vue?vue&type=style&index=0&id=440ba208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440ba208",
  null
  
)

export default component.exports